<app-confirmation-modal
  [title]="versionUpdatesCopy()?.updateMessageTitle || ''"
  [visible]="!!(isRefreshByModalRequired$ | async)"
  [submitLabel]="versionUpdatesCopy()?.updateActionLabel || ''"
  [message]="versionUpdatesCopy()?.updateMessage || ''"
  [noCancel]="true"
  (confirmAction)="refreshPage()"
></app-confirmation-modal>
<div class="app-container" [ngClass]="{ 'for-agent-bar': (isAgentUser$ | async) }">
  <div class="debug-version text-black-400 border-grey-100" *ngIf="showVersion" role="application">
    <span class="p3">
      {{ env }} <span class="font-bold">v{{ versionNo }}</span>
      <span *ngIf="patient$ | async"
        ><br />Patient ID <span class="font-bold">{{ (patient$ | async)?.id }}</span></span
      >
    </span>
  </div>
  <router-outlet></router-outlet>
  <p-toast key="appToast" position="top-right" data-cy="bottom-center-toast"></p-toast>
</div>
